import {SET_SOUND_KEY} from "@actions/actionTypes"

export default function soundKeyReducer(state = "", action) {
    switch (action.type) {
        case SET_SOUND_KEY:
            return action.payload
        default:
            return state;
    }
}